import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";
import { rgba } from "emotion-rgba";


export const Wrapper = styled.div`
  min-height: 100vh;
`;

export const Main = styled.div`
  min-height: calc(100vh - 42px);
  margin-top:42px;

  .add-address {
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid rgba(0, 19, 37, 0.16);
    padding-bottom: 3px;
    button {
      padding-left: 0px;
      padding-right: 0px;
    }
    .title {
      margin-left: 20px;
    }
    margin-left: 20px;
    margin-right: 20px;
    width: 90%;

  }

  .bottom-fixed {
    position: fixed;
    bottom:0;
    left:0;
    right:0;
    padding:5px 20px;
    font-size: 12px;
    box-shadow: inset 0px 1px 0px rgb(0 19 37 / 16%);
    background: white;
  }

  .footer {
    font-size: 12px;
    margin-top: 25px;
    margin-bottom: 100px;
  }

  button {
    border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};
    padding-top: 10px;
  }

  .check {
    position: absolute;
    right: 12px;
  }
`;

export const CardWrapper:any = styled.div`
  padding : 20px;
  padding-bottom: 0px;
  background: ${({ theme, isChecked }: any) => isChecked ? rgba(theme.brandtextPrimaryColor, 0.04) : ""};

  .default {
    color: #1C7DFF;
    font-size: 10px;
  }

  .label {
    background-color: ${({ theme }: ThemeStyle) => rgba(theme.grey.G10, 0.08)};
    border-radius: 20px;
    width: 66px;
    height: 24px;
    text-align: center;
    margin-left: 4px;
    padding: 2px;
    color: rgba(0, 19, 37, 0.64);
  }

  .address {
    padding-right: 50px;
    color: rgba(0, 19, 37, 0.64);
    padding-bottom: 10px;
    overflow-wrap: anywhere;
  }
  .edit-address{
    position: absolute;
    right: 20px;
    color: ${({ theme }: ThemeStyle) => theme.brandtextPrimaryColor}
  }
`;
